import { useRef } from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import dateFormat from 'dateformat';

import styles from '@containers/Dashboard/Dashboard.module.scss';

import {
  BalanceThresholdTable,
  OpenOrderTable,
} from '@components/Dashboard/ActionItems/Table';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page500 } from '@containers/ErrorPages';
import { billingApi } from '@reducers/billing';
import { dashboardApi } from '@reducers/dashboard/dashboard';
import { skipToken } from '@reduxjs/toolkit/query';

const renderTodayDate = () => {
  const date = new Date();
  const formattedDate = dateFormat(date, 'd mmm yyyy');
  const formattedTime = dateFormat(date, 'shortTime');
  return (
    <div className={styles.dashboardDate}>
      {formattedDate}
      <span>{formattedTime}</span>
    </div>
  );
};

export const ActionItems = () => {
  const actionRef = useRef(null);
  const { login, isPrepaid } = useSelector((state) => state.auth.user);
  const openOrdersQuery = dashboardApi.useGetOpenOrdersQuery();
  const balanceQuery = billingApi.useGetBalanceQuery(
    isPrepaid ? { login } : skipToken
  );

  return (
    <Card className={`${styles.actionCardSize}`}>
      <Card.Header className="text-center bg-didxl text-white">
        Action items
      </Card.Header>
      <Card.Body
        id="action-items"
        className={`${styles.actionCardScroll} ${styles.firstRow}`}
        ref={actionRef}
      >
        {isPrepaid ? (
          <>
            <Card.Title className="largeFontSize">Balance</Card.Title>
            <Card.Text as="div" className="normalFontSize">
              {balanceQuery.isError ? <Page500 /> : null}
              {balanceQuery.isLoading || balanceQuery.isFetching ? (
                <DefaultSpinnerCenter />
              ) : null}
              {!balanceQuery.isLoading && !balanceQuery.isError ? (
                <BalanceThresholdTable
                  data={[
                    {
                      belowThreshold: balanceQuery.data.is_below_threshold,
                      date: renderTodayDate(),
                    },
                  ]}
                />
              ) : null}
            </Card.Text>
          </>
        ) : null}
        <Card.Title className="largeFontSize">Open orders</Card.Title>
        <Card.Text as="div" className="normalFontSize">
          {openOrdersQuery.isError ? <Page500 /> : null}
          {openOrdersQuery.isLoading || openOrdersQuery.isFetching ? (
            <DefaultSpinnerCenter />
          ) : null}
          {!openOrdersQuery.isLoading && !openOrdersQuery.isError ? (
            <OpenOrderTable data={openOrdersQuery.data} ref={actionRef} />
          ) : null}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};
